package com.gsb.vyapar.bhagya.datasource.mqtt

sealed class MQTTCallback {
    data class CreateMqttClient(val status: (Result<Unit>) -> Unit) : MQTTCallback()
    data class Connect(val status: (Result<Unit>) -> Unit) : MQTTCallback()
    data class Disconnect(val status: (Result<Unit>) -> Unit) : MQTTCallback()
    data class Subscribe(val topic: String, val status: (Result<Unit>) -> Unit) : MQTTCallback()
    data class UnSubscribe(val topic: String, val status: (Result<Unit>) -> Unit) : MQTTCallback()
    data class Publish(val topic: String, val message: String, val status: (Result<Unit>) -> Unit) : MQTTCallback()
}